import Link from 'molecules/Link';

import styles from 'components/HealthcareEntries/Breadcrumbs/breadcrumbs.module.scss';

import type { ComponentPropsWithRef, FC } from 'react';

interface BreadcrumbsProps extends ComponentPropsWithRef<'nav'> {
  basePathText: string;
  secondPathText: string;
  queryParam: string;
  basePathUrl: string;
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ basePathText, secondPathText, basePathUrl, queryParam }) => {
  const url = `${basePathUrl}?Content+Type=${queryParam
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')}`;
  const links = [
    {
      text: basePathText,
      url: basePathUrl,
    },
    {
      text: secondPathText,
      url,
    },
  ];

  return (
    <nav aria-label="Breadcrumbs">
      <ul className={styles.breadcrumbsContainer}>
        {links.map((link, index) => (
          <li key={link.text}>
            {index ? <span aria-hidden="true">/</span> : null}
            <Link className={styles.breadcrumbsLinks} href={link.url}>
              {link.text}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
